import classNames from 'classnames';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import React from 'react';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import DatePicker from 'react-datepicker';
import { Trans } from 'react-i18next';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';

import { DatePickerInput } from '../components/forms/fields/CustomDatePicker';
import { debounce, fetchFromObject } from '../libs/utils';
import Pagination from './Pagination';

class ListView extends React.Component {
  constructor(props) {
    super(props);

    let { baseFilters, filters, dataSet } = this.props.config;

    const parsedFilters = queryString.parse(window.location.search);
    baseFilters = { ...baseFilters, ...parsedFilters };

    const _filterHandlers = {};
    const _filterOptions = {};

    if (filters) {
      filters.forEach(
        function (filter) {
          // expand the base filter with a prop for each filter
          if (!baseFilters['filter[' + filter.key + ']']) {
            baseFilters['filter[' + filter.key + ']'] = '';
          }

          // attach a filterHandler for each filter so it can be called from render
          if (filter.type === 'text') {
            _filterHandlers[filter.key] = debounce(
              function () {
                this._setFilter(
                  'filter[' + filter.key + ']',
                  document.querySelector('#' + filter.key + 'Search').value
                );
              }.bind(this),
              250
            );
          } else if (filter.type === 'typeahead') {
            _filterHandlers[filter.key] = function (value) {
              filter
                .options(value)
                .then(
                  function (response) {
                    const newState = {
                      filterOptions: { ...this.state.filterOptions },
                    };

                    newState.filterOptions[filter.key] = response.data;

                    this.setState(newState);
                  }.bind(this)
                )
                .catch((err) => {});
            }.bind(this);
          } else if (filter.type === 'checkbox') {
            _filterHandlers[filter.key] = function (value) {
              const checkboxValue = document.querySelector('#' + filter.key + 'Search').checked
                ? document.querySelector('#' + filter.key + 'Search').value
                : '';
              this._setFilter('filter[' + filter.key + ']', checkboxValue);
            }.bind(this);
          } else if (filter.type === 'select') {
            _filterHandlers[filter.key] = function (value) {
              const checkboxValue = document.querySelector('#' + filter.key.replace('.', '_') + 'Search').value;
              this._setFilter('filter[' + filter.key + ']', checkboxValue);
            }.bind(this);
          }

          _filterOptions[filter.key] = [];
        }.bind(this)
      );
    }

    this._filterHandlers = _filterHandlers;

    this.state = {
      filters: baseFilters,
      filterOptions: _filterOptions,
      dataSet,
    };

    this._setFilter = this._setFilter.bind(this);
    this._handlePageChange = this._handlePageChange.bind(this);
    this._handlePageSizeChange = this._handlePageSizeChange.bind(this);
  }

  static propTypes = {
    config: PropTypes.object,
    handleFilterUpdate: PropTypes.func,
    handleDelete: PropTypes.func,
    inPortlet: PropTypes.bool,
    history: PropTypes.object,
    location: PropTypes.object,
  };

  UNSAFE_componentWillUpdate(nextProps, nextState) {
    if (this.state.filters !== nextState.filters) {
      this.props.handleFilterUpdate(nextState.filters);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      dataSet: nextProps.config.dataSet,
    });
  }

  componentDidUpdate() {
    ReactTooltip.rebuild();
  }

  _handlePageChange(pageNumber) {
    this._setFilter('page[number]', pageNumber);
  }

  _handlePageSizeChange(pageSize) {
    this._setFilter('page[size]', pageSize);
  }

  _setOrder(e, key) {
    e.preventDefault();
    if (this.state.filters.sort === key) {
      this._setFilter('sort', '-' + key);
    } else {
      this._setFilter('sort', key);
    }
  }

  _setFilter(key, value) {
    console.log('_setFilter', key, value);
    let newState = {
      filters: {
        ...this.state.filters,
      },
    };
    newState.filters[key] = value;
    const stringified = queryString.stringify(newState.filters);
    this.props.history.push({
      search: stringified,
    });
    this.setState(newState);
  }

  render() {
    const { filterOptions, dataSet: dataSetOriginal, filters: baseFilters } = this.state;
    const { inPortlet, keepPadding } = this.props;
    const { columns, url, filters, actions, dataMeta, customRowRenderer, customHeaderRenderer, customKey } =
      this.props.config;

    const dataSet = customKey
      ? dataSetOriginal.map((item) => {
          item.id = item[customKey];
          return item;
        })
      : dataSetOriginal;

    const filterWidth = filters ? Math.floor(12 / filters.length) : 0;

    return (
      <div
        className={classNames({
          'listview': !keepPadding,
          'm-portlet': !inPortlet,
        })}
      >
        <ReactTooltip />
        {filters && filters.length > 0 && (
          <div className="m-portlet__head">
            <div className="row">
              {filters.map((filter) => {
                return (
                  <div
                    className={'filter filter-' + filter.type + ' col-xl-' + (filter.col ? filter.col : filterWidth)}
                    key={filter.key}
                  >
                    <div className="form-group m-form__group">
                      {(filter.type === 'text' ||
                        filter.type === 'select' ||
                        filter.type === 'typeahead' ||
                        filter.type === 'datepicker') && (
                        <div className="input-group">
                          <div className="input-group-prepend">
                            <span className="input-group-text" id="basic-addon1">
                              <i className={`la ${filter.icon} m--margin-right-10`} /> <Trans>{filter.label}</Trans>
                            </span>
                          </div>
                          {filter.type === 'text' && (
                            <input
                              type="text"
                              id={filter.key + 'Search'}
                              className="form-control m-input"
                              defaultValue={baseFilters[`filter[${filter.key}]`]}
                              onChange={this._filterHandlers[filter.key]}
                            />
                          )}

                          {filter.type === 'select' && (
                            <select
                              className="form-control m-input"
                              id={filter.key.replace('.', '_') + 'Search'}
                              onChange={this._filterHandlers[filter.key]}
                              value={baseFilters[`filter[${filter.key}]`]}
                            >
                              <option value="">Select {filter.label}</option>
                              {filter.dataset.map((option) => (
                                <option value={String(option.key)} key={option.key}>
                                  {option.value}
                                </option>
                              ))}
                            </select>
                          )}

                          {filter.type === 'typeahead' && (
                            <AsyncTypeahead
                              multiple={false}
                              options={filterOptions[filter.key]}
                              defaultValue={baseFilters[`filter[${filter.key}]`]}
                              isLoading={false}
                              placeholder={'Search ...'}
                              minLength={2}
                              labelKey={filter.labelKey}
                              onSearch={this._filterHandlers[filter.key]}
                              id={filter.key + 'Typeahead'}
                              onChange={(value) => {
                                this._setFilter('filter[' + filter.key + ']', value.length > 0 ? value[0].id : '');
                              }}
                            />
                          )}

                          {filter.type === 'datepicker' && (
                            <DatePicker
                              customInput={<DatePickerInput {...this.props} HTMLname={filter.key} />}
                              onChange={(value) => {
                                this._setFilter('filter[' + filter.key + ']', value.format('YYYY-MM-DD'));
                              }}
                              dateFormat="DD/MM/YYYY"
                              value={baseFilters[`filter[${filter.key}]`]}
                              showMonthDropdown={true}
                              showYearDropdown={true}
                              dropdownMode="select"
                            />
                          )}
                        </div>
                      )}

                      {filter.type === 'checkbox' && (
                        <div className="m-checkbox-list">
                          <label className="m-checkbox">
                            <input
                              type="checkbox"
                              id={filter.key + 'Search'}
                              onChange={this._filterHandlers[filter.key]}
                              value={filter.value}
                              checked={String(baseFilters['filter[' + filter.key + ']']) === String(filter.value)}
                            />{' '}
                            {filter.label}
                            <span />
                          </label>
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        <div className="m-portlet__body">
          {dataSet.length > 0 ? (
            <table className="table m-table m-table--head-separator-success">
              <thead>
                {customHeaderRenderer ? (
                  customHeaderRenderer()
                ) : (
                  <tr>
                    {columns.map((column) => {
                      return (
                        <th key={column.key}>
                          <a
                            href="#"
                            className={
                              'order-icon' +
                              (this.state.filters['sort'] === column.sort ? ' active' : '') +
                              (this.state.filters['sort'] === '-' + column.sort ? ' active reverse' : '')
                            }
                            onClick={(e) => {
                              column.sort && this._setOrder(e, column.sort);
                            }}
                            style={{ whiteSpace: 'nowrap' }}
                          >
                            <Trans>{column.value}</Trans>&nbsp; {column.sort && <span className="la la-angle-down" />}
                          </a>
                        </th>
                      );
                    })}
                    <th />
                  </tr>
                )}
              </thead>
              <tbody>
                {dataSet.map((item, i) => {
                  if (customRowRenderer) {
                    return customRowRenderer(item, i);
                  } else {
                    return (
                      <tr key={item.id}>
                        {columns.map((column) => {
                          return (
                            <td key={item.id + '/' + column.key}>
                              {column.render ? column.render(item) : fetchFromObject(item, column.key)}
                            </td>
                          );
                        })}

                        <td className="text-right" style={{ whiteSpace: 'nowrap' }}>
                          {actions.customLink && actions.customLink(item)}
                          {actions.detailsLink && (
                            <span>
                              {actions.detailsFunction ? (
                                <button
                                  type="button"
                                  className="btn btn-outline-success m-btn btn-sm  m-btn--icon m--margin-left-5"
                                  onClick={() => actions.detailsFunction(item)}
                                >
                                  <span>
                                    <i className="la la-warning" />
                                    <span>
                                      <Trans>Delete</Trans>
                                    </span>
                                  </span>
                                </button>
                              ) : (
                                <Link
                                  to={url + '/' + item.id}
                                  className="btn btn-outline-success m-btn btn-sm  m-btn--icon m--margin-left-5"
                                >
                                  <span>
                                    <i className="la la-eye" />
                                    <span>
                                      <Trans>Details</Trans>
                                    </span>
                                  </span>
                                </Link>
                              )}
                            </span>
                          )}

                          {actions.editLink &&
                            ((actions.editHideFunction && !actions.editHideFunction(item)) ?? true) && (
                              <span>
                                {actions.editFunction ? (
                                  <button
                                    type="button"
                                    className="btn btn-outline-primary m-btn btn-sm  m-btn--icon m--margin-left-5"
                                    onClick={() => actions.editFunction(item)}
                                  >
                                    <span>
                                      <i className="la la-pencil" />
                                      <span>
                                        <Trans>Edit</Trans>
                                      </span>
                                    </span>
                                  </button>
                                ) : (
                                  <Link
                                    to={url + '/' + item.id + '/edit'}
                                    className="btn btn-outline-primary m-btn btn-sm  m-btn--icon m--margin-left-5"
                                  >
                                    <span>
                                      <i className="la la-pencil" />
                                      <span>
                                        <Trans>Edit</Trans>
                                      </span>
                                    </span>
                                  </Link>
                                )}
                              </span>
                            )}

                          {actions.deleteLink &&
                            ((actions.deleteHideFunction && !actions.deleteHideFunction(item)) ?? true) && (
                              <span>
                                {actions.deleteFunction ? (
                                  <button
                                    type="button"
                                    className="btn btn-outline-danger m-btn btn-sm  m-btn--icon m--margin-left-5"
                                    onClick={() => actions.deleteFunction(actions.fullDelete ? item : item.id)}
                                  >
                                    <span>
                                      <i className="la la-warning" />
                                      <span>
                                        <Trans>{actions.deleteLabel ?? 'Delete'}</Trans>
                                      </span>
                                    </span>
                                  </button>
                                ) : (
                                  <Link
                                    to={url + '/' + item.id}
                                    className="btn btn-outline-danger m-btn btn-sm  m-btn--icon m--margin-left-5"
                                  >
                                    <span>
                                      <i className="la la-warning" />
                                      <span>
                                        <Trans>Delete</Trans>
                                      </span>
                                    </span>
                                  </Link>
                                )}
                              </span>
                            )}
                        </td>
                      </tr>
                    );
                  }
                })}
              </tbody>
            </table>
          ) : (
            <div>
              <Trans>No Results</Trans>
            </div>
          )}
        </div>
        <div className="m-portlet__foot">
          {dataMeta && (
            <Pagination
              meta={dataMeta}
              pageChange={this._handlePageChange}
              pageSizeChange={this._handlePageSizeChange}
            />
          )}
        </div>
      </div>
    );
  }
}

export default withRouter(ListView);
